import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinOpenChange, FadvBaseComponent, Forward, openChangeInput, openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/alert/alert';

class FadvAlertIconDirective {
    constructor() {
        this.slotName = 'icon';
    }
}
FadvAlertIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvAlertIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvAlertIconDirective, selector: "[fadvAlertIcon]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvAlertIcon]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvAlertComponent extends mixinOpenChange(FadvBaseComponent) {
    constructor(el) {
        super(el);
        /* The ability to close the alert */
        this.closable = false;
        /* How long the alert will be open before it closes automatically in milliseconds */
        this.duration = undefined;
        this.variant = 'primary';
    }
    toast() {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.toast();
    }
}
FadvAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAlertComponent, selector: "fadv-alert", inputs: { open: "open", closable: "closable", duration: "duration", variant: "variant" }, outputs: { openChange: "openChange", shown: "shown", hidden: "hidden" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvAlertComponent.prototype, "closable", void 0);
__decorate([
    Forward()
], FadvAlertComponent.prototype, "duration", void 0);
__decorate([
    Forward()
], FadvAlertComponent.prototype, "variant", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-alert',
                    template: '<ng-content></ng-content>',
                    inputs: [openChangeInput],
                    outputs: [openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { closable: [{
                type: Input
            }], duration: [{
                type: Input
            }], variant: [{
                type: Input
            }] } });

class FadvAlertModule {
}
FadvAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertModule, declarations: [FadvAlertComponent, FadvAlertIconDirective], imports: [FadvCommonModule], exports: [FadvAlertComponent, FadvAlertIconDirective] });
FadvAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvAlertComponent, FadvAlertIconDirective],
                    imports: [FadvCommonModule],
                    exports: [FadvAlertComponent, FadvAlertIconDirective],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvAlertComponent, FadvAlertIconDirective, FadvAlertModule };
